import { useReportApi } from "../api/ReportApiClient";
import { ReportFrontendService } from "../services/ReportFrontendService";

export const useReportService = (): ReportFrontendService =>
  new ReportFrontendService(useReportApi());
